import * as baseAdapter from './baseAdapter';
import { IBentoOrderRes, ISyncOrderBento } from '@/interfaces/order';

export const getLastSync = async () => {
  const ret = await baseAdapter.get<{ data: ISyncOrderBento }>(
    '/v1/order/get-last-sync',
  );
  return ret?.data?.data;
};

export const sync = async () => {
  const ret = await baseAdapter.post('/v1/order/sync', '');
  return ret?.data;
};

export const getOrders = async () => {
  const ret = await baseAdapter.get<IBentoOrderRes[]>('/v1/order/gets');
  return ret?.data;
};

export const createOrders = async (data: IBentoOrderRes[]) => {
  const ret = await baseAdapter.post<any>('/v1/order/create', data);
  return ret?.data;
};
